<template>
  <CHeader class="snet-header c-header c-header-dark" fixed primary>
    <CToggler
      in-header
      class="ml-3 d-lg-none light-header-content"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none light-header-content"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" width="100" alt="Logo"/>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
    </CHeaderNav>
    <div class="onnet-div">
      <connect-switch v-if="onNet && site.legacysite === false" class="onnet-switch"></connect-switch>
    </div>
  </CHeader>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import store from '@/store'
import ConnectSwitch from '../components/captive/ConnectSwitch.vue'

export default {
  components: { ConnectSwitch },
  name: 'Header',
  componenets: {
    ConnectSwitch
  },
  data() {
    return {
      onnet: false
    }
  },
  computed: {   
    ...mapGetters({
      onNet: 'captive/isOnNet',
      site: 'account/site'
    })
  }
}
</script>

<style lang="scss" scoped>
  .onnet-switch {
    margin: auto;
  }
  .onnet-div {
    display: inline-flex;
  }

  .snet-header {
    background-color: #612761; 
  }

  .light-header-content {
    color: #ffffff !important;
    font-weight: 400;
  }

</style>
